import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'

// 读取配置文件中的网站标题
let strSiteName = require('@/config/global').title



const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)
const Login = () => import('views/login/Login')
const Home = () => import('views/home/Home')
const Staff = () => import('views/staff/Staff')
const BatchImport = () => import('views/staff/BatchImport')
const Balance = () => import('views/balance/Balance')
const Profile = () => import('views/profile/Profile')
const InviteStatistics = () => import('views/inviteStatistics/InviteStatistics')
const FirstStaff = () => import('views/inviteStatistics/FirstStaff')
const CardList = () => import('views/cardManage/cardList')
const DiscountCode = () => import('views/discountCode/DiscountCode')

const routes = [
	{
		path: '',
		redirect: '/home'
	},
	{
		path: '/home',
		component: Home,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/profile',
		component: Profile,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/balance',
		component: Balance,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/staff',
		component: Staff,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/import',
		component: BatchImport,
		meta: {
			title: strSiteName
		}
	}, {
		path: '/inviteStatistics',
		component: InviteStatistics,
		meta: {
			title: strSiteName
		}
	}, {
		path: '/firstStaff',
		component: FirstStaff,
		meta: {
			title: strSiteName
		}
	}, {
		path: '/cardList',
		component: CardList,
		meta: {
			title: strSiteName
		}
	},
	{
		path: '/discountCode',
		component: DiscountCode,
		meta: {
			title: strSiteName
		}
	},

	{
		path: '/login',
		component: Login,
		meta: {
			title: strSiteName
		}
	},
]

const router = new VueRouter({
	scrollBehavior: () => ({ y: 0 }),
	routes,
	mode: 'history'
})

router.beforeEach((to, from, next) => {
	window.document.title = to.meta.title

	const TOKEN = localStorage.getItem('token')
	// const TOKEN =  JSON.parse(sessionStorage.getItem("store")).token;
	if (!TOKEN) {
		if (to.path === '/login') {
			next()
		} else {
			localStorage.setItem('go-url', to.fullPath)
			next('/login')
		}
	} else {
		if (to.path == '/login') {
			next('/home')
		}
		next()
	}
	next()
})

export default router
